import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, Send } from 'lucide-react';
import { HitlStepArtifact } from '../types';
interface Props {
  artifact: HitlStepArtifact;
  breadcrumb?: string;
  onAnswer: (answer: string) => void;
  onViewInSession?: () => void;
}
export function HitlStepCard({
  artifact,
  breadcrumb,
  onAnswer,
  onViewInSession
}: Props) {
  const [openInput, setOpenInput] = useState('');
  const isResolved = artifact.status === 'resolved';
  return <motion.div layout className={`bg-[#1c1c22] rounded-[16px] overflow-hidden ${isResolved ? 'border border-white/[0.04]' : 'border-l-[3px] border-l-[#e8a84c] border-y border-r border-white/[0.04]'}`} data-id="element-447">
      {breadcrumb && <div className="px-4 pt-3 text-[11px] text-[#8a8680]/60 tracking-wide" data-id="element-448">{breadcrumb}</div>}
      <div className="flex items-center gap-2 px-4 pt-3 pb-2" data-id="element-449">
        <HelpCircle size={14} className="text-[#e8a84c]" strokeWidth={1.5} data-id="element-450" />
        <span className="text-[11px] text-[#e8a84c] uppercase tracking-wide" data-id="element-451">Needs your input</span>
        <span className="text-[11px] text-[#8a8680]/60 ml-auto" data-id="element-452">{artifact.timestamp}</span>
      </div>
      <div className="px-4 pb-4" data-id="element-453">
        <h3 className="text-[14px] text-[#e8e4df] mb-3" data-id="element-454">{artifact.title}</h3>
        <p className="text-[13px] text-[#e8e4df]/80 leading-relaxed mb-4" data-id="element-455">{artifact.question}</p>

        {isResolved ? <div className="bg-[#4a9a9a]/10 border border-[#4a9a9a]/30 rounded-[10px] px-3 py-2" data-id="element-456">
            <div className="text-[11px] text-[#4a9a9a] uppercase tracking-wide mb-1" data-id="element-457">Your answer</div>
            <div className="text-[13px] text-[#e8e4df]" data-id="element-458">{artifact.answer}</div>
          </div> : artifact.mode === 'choice' && artifact.choices ? <div className="space-y-2" data-id="element-459">
            {artifact.choices.map(choice => <button key={choice.key} onClick={() => onAnswer(choice.label)} className="w-full flex items-start gap-3 px-3 py-2.5 bg-white/[0.03] hover:bg-[#4a9a9a]/10 border border-transparent hover:border-[#4a9a9a]/30 rounded-[10px] text-left transition-colors group" data-id="element-460">
                <span className="text-[12px] text-[#4a9a9a] font-mono mt-0.5 min-w-[20px]" data-id="element-461">{choice.key}</span>
                <span className="text-[13px] text-[#e8e4df] flex-1" data-id="element-462">{choice.label}</span>
              </button>)}
          </div> : <div className="flex items-center gap-2 bg-white/[0.03] rounded-[10px] px-3 py-2" data-id="element-463">
            <input value={openInput} onChange={e => setOpenInput(e.target.value)} placeholder="Type your reply…" className="flex-1 bg-transparent text-[13px] text-[#e8e4df] placeholder:text-[#8a8680]/60 outline-none" onKeyDown={e => {
          if (e.key === 'Enter' && openInput.trim()) {
            onAnswer(openInput.trim());
            setOpenInput('');
          }
        }} data-id="element-464" />
            <button onClick={() => {
          if (openInput.trim()) {
            onAnswer(openInput.trim());
            setOpenInput('');
          }
        }} className="w-7 h-7 flex items-center justify-center rounded-full bg-[#4a9a9a]/20 text-[#4a9a9a] hover:bg-[#4a9a9a]/30 transition-colors" data-id="element-465">
              <Send size={12} strokeWidth={1.8} data-id="element-466" />
            </button>
          </div>}

        {onViewInSession && <button onClick={onViewInSession} className="mt-3 text-[11px] text-[#8a8680] hover:text-[#4a9a9a] transition-colors" data-id="element-467">
            View in session →
          </button>}
      </div>
    </motion.div>;
}